import "./index.css"
import { useEffect } from "react"
import { Alert, Skeleton } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { obtenerExtraCotizacion } from "../../../ducks/clientesDuck"
import { formatDinero } from './../../../utils/formatDinero'
import { FormatoFechaIso } from './../../../utils/FormatFecha'
import { useContratacion } from "../../../hooks/useContratacion"
import { Divider } from "@material-ui/core"
import { esFinalizado } from "../../../utils/esFinalizado"
const TarjetaExtra = () => {
    const { idCotizacion, extraCotizacion, referencia } = useSelector(store => store.cliente)
    const dispatch = useDispatch()
    const [contratacion] = useContratacion({ referencia })
    const extrasPaquete = contratacion.PaqueteContratado?.ListaSuplementoContratado ?? []

    useEffect(() => {
        dispatch(obtenerExtraCotizacion({ idCotizacion }))
    }, [dispatch, idCotizacion])

    if (contratacion.IdContratacion > 0)
        return (
            <div className="TarjetaExtra-root">
                <div className="contenido" style={{ padding: "20px" }}>
                    <div style={{ margin: "2% 0" }}>
                        <h4>{`Monto contratación: ${formatDinero(contratacion?.MontoContratacion)} ${contratacion?.Moneda}`}</h4>
                        <h4>{`Numero de pasajeros: ${contratacion?.NumeroPersonas}`}</h4>
                        <h4>{`Fecha contratación: ${FormatoFechaIso({ date: contratacion?.FechaContrato, formato: "dd/MM/yyy" })}`}</h4>
                        <h4>{`Email Agente: ${contratacion?.AgenteEmail}`}</h4>
                        <Divider />
                        <h4>{`Nombre paquete:`}
                            <div dangerouslySetInnerHTML={{ __html: `${contratacion?.PaqueteContratado?.Nombre}` }} />
                        </h4>
                        <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Precio paquete: ${formatDinero(contratacion?.PaqueteContratado?.Precio)} ${contratacion?.Moneda}`}</h4>
                        <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Total: ${formatDinero(contratacion?.PaqueteContratado?.Precio * contratacion?.NumeroPersonas)} ${contratacion?.Moneda}`}</h4>
                        <div dangerouslySetInnerHTML={{ __html: `${contratacion?.PaqueteContratado?.Descripcion}` }} />
                    </div>
                    <Divider />
                    {
                        extrasPaquete.map((item, index) =>
                            <div key={item.IdExtraPaqueteProveedor} style={{ margin: "2% 0" }}>
                                <h4>{`Tipo suplemento: ${item?.TipoSuplemento}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Cantidad: ${item?.Cantidad}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Monto suplemento: ${formatDinero(item?.Precio)} ${contratacion?.Moneda}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Total: ${formatDinero(item?.Precio * item?.Cantidad)} ${contratacion?.Moneda}`}</h4>
                                <h4 style={{marginBottom: "0", marginTop: "0"}}>{`Fecha contratación: ${FormatoFechaIso({date: item?.FechaRegistro, formato: "dd/MM/yyyy"})}`}</h4>
                                <h4>{`Nombre suplemento:`}
                                    <div dangerouslySetInnerHTML={{ __html: `${item?.Nombre}` }} />
                                </h4>
                                <div dangerouslySetInnerHTML={{ __html: `${item?.Descripcion ?? ""}` }} />
                                <Divider />
                            </div>
                        )
                    }
                </div>
            </div>
        )

    if (extraCotizacion.length > 0)
        return (
            <div className="TarjetaExtra-root">
                <div className="contenido">
                    {
                        extraCotizacion.map((extra, index) =>
                            <div key={index}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Costo: ${formatDinero(extra.Costo)} ${extra.Moneda.Nombre}`}
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Comision: ${formatDinero(extra.Comision)}`}
                                        </li>
                                    </ul>
                                    <ul style={{ listStyle: 'none', display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "flex-start", padding: "0 0 0 10px" }}>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Cantidad: ${extra.Cantidad}`}
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                            {`Total: ${formatDinero(extra.Total)}  ${extra.Moneda.Nombre}`}
                                        </li>
                                    </ul>
                                </div>
                                <div style={{ padding: "20px" }} dangerouslySetInnerHTML={{ __html: `${extra.Extra}` }} />
                            </div>
                        )
                    }
                </div>
            </div>
        )
    return (
        <div className="TarjetaExtra-root">
            <div className="contenido">
                <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
                <Skeleton variant="rect" height={350} />
            </div>
        </div>
    )

}
export default TarjetaExtra